import { createAction } from '@ngrx/store';
import { UserEntity } from 'src/app/models';


export const logout = createAction('USER_LOGOUT');
